import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { environment } from "src/environments/environment";
import { StudentsFilterModel } from "common/models/page-models/student/filtermodel/student-filter.data.model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { InternshipFilterModel } from "common/models/page-models/Student Internship List/Intership Filter Form/internship-list-filter-data.model";


@Injectable({
    providedIn: 'root'
})
export class InternshipFilterDataService extends FormDataService<InternshipFilterModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.intershipGrid, http, ss);
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.IntershipListForSuperAdmin,
            method: API_METHODS.post
        }
        return edit;
    }

    createInstance(): InternshipFilterModel {
        return new InternshipFilterModel();
    }
}

export { FormDataService };
